import React, { createElement } from 'react';
import { Helmet } from 'react-helmet-async';
export function GoogleTagManager() {
  const GTM_ID = 'GTM-M56PBMX5';
  return <>
      <Helmet data-id="element-141">
        <script data-id="element-142">
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`}
        </script>
      </Helmet>
      <noscript data-id="element-143">
        <iframe src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`} height="0" width="0" style={{
        display: 'none',
        visibility: 'hidden'
      }} data-id="element-144" />
      </noscript>
    </>;
}